/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Role } from '../../models/role';

export interface ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Params {
  userId?: string;
  Authorization?: string;
}

export function apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Role>>;
    })
  );
}

apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain.PATH = '/api/keycloak/GetAvailableClientRoleMappingsForUser';
